{
  "en": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> View",
          "other": "%{label}:<br><b>%{count}</b> Views"
        },
        "pledgePrice": "%{label}:<br><b>%{count}</b> USD",
        "ingamePrice": "%{label}:<br><b>%{count} %</b>",
        "wishToOwnRatio": "%{label}:<br><b>%{count}</b> wished per 100 owned",
        "patchChange": {
          "one": "%{label}:<br><b>%{count}</b> Change",
          "other": "%{label}:<br><b>%{count}</b> Changes"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> Ship",
          "other": "%{label}:<br><b>%{count}</b> Ships"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> Ship (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Ships (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> Component (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Components (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> User",
          "other": "%{label}:<br><b>%{count}</b> Users"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> Visit",
          "other": "%{label}:<br><b>%{count}</b> Visits"
        },
        "supporterContribution": {
          "amount": "Contributions: <b>%{amount}</b>",
          "goal": "Goal: <b>%{amount}</b>",
          "count": {
            "one": "<b>%{count}</b> supporter",
            "other": "<b>%{count}</b> supporters"
          }
        }
      },
      "states": {
        "empty": "No data to chart yet",
        "failed": "This chart could not be loaded",
        "retry": "Try again"
      }
    }
  }
}
